import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-white-plubs",
  "use": "icon-white-plubs-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 25\" fill=\"none\" id=\"icon-white-plubs\">\n  <rect x=\"11\" y=\"2.60156\" width=\"2\" height=\"20\" fill=\"white\" />\n  <rect x=\"2\" y=\"13.6016\" width=\"2\" height=\"20\" transform=\"rotate(-90 2 13.6016)\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol